export const pluralize = (number: number, single: string, plural: string) => {
  return number > 1 ? plural : single;
};
